import { render, staticRenderFns } from "./CmgGiftCard.vue?vue&type=template&id=2103df25&scoped=true&lang=pug&"
import script from "./cmg-gift-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-gift-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGiftCard.vue?vue&type=style&index=0&id=2103df25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103df25",
  null
  
)

export default component.exports